import api from 'api';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from 'redux/reducers';
import './recordingSearch.scss';
import { RecordingType, RootState, StationProgramScheduleType, StationType } from 'types';
import Table from 'components/table'
import { toast } from 'react-toastify';

export default function RecordingSearch() {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const onSubmit = (data: any) => getRecordings(data.Program);
  if (errors.length > 0)
    console.log(errors);
  
  const dispatch = useDispatch();

  const state = useSelector((state: RootState) => state);
  const [stations, setStations] = useState<StationType[]>([]);
  const [programSchedules, setProgramSchedules] = useState<StationProgramScheduleType[]>([]);
  const [recordings, setRecordings] = useState<RecordingType[]>([]);
  const [data, setData] = useState<RecordingType[]>([]);
  const [page, setPage] = useState<number>(1);
  const [checked, setChecked] = useState<number[]>([]);
  const [showEndResults, setEndResults] = useState<boolean>(false);

  const loadMore = () => {
    setPage(page + 1);
  }
  
  useEffect(() => {
      // setLoading(true);
      api.broadcast.getStationsAll()
      .then(data => {
          setStations(data);
      })
  }, [dispatch]);
  
  useEffect(() => {
    if (stations.length > 0)
      getPrograms(stations[0].Id);
  }, [stations])
  
  useEffect(() => {
    if (programSchedules.length > 0)
      getRecordings(programSchedules[0].ProgramScheduleId);
  }, [programSchedules])

  useEffect(() => {
    setEndResults(false);
    setPage(1);
    setData(recordings.slice(0, 25 * page));
  }, [recordings])
  
  useEffect(() => {
    if (data.length == recordings.length)
      setEndResults(true);
    else
      setEndResults(false);
  }, [data])

  useEffect(() => {
    setData(recordings.slice(0, 25 * page));
  }, [page])

  const handleOnChange = (e: any) => {
    switch (e.currentTarget.name) {
      case "Station":
        getPrograms(e.currentTarget.value);
        break;
      case "Program":
        getRecordings(e.currentTarget.value);
        break;
      default:
        console.log(`Handling ${e.currentTarget.name} not implemented`);
        break;
    }
  }

  const getPrograms = (id: number) => {
    api.broadcast.getSchedule(id).then(data => {
      setProgramSchedules(data);
    })
  }

  const getRecordings = (id: number) => {
    var schedule = programSchedules.find(x => x.ProgramScheduleId == id);
    api.broadcast.getRecordings(schedule).then(data => {
      if (null == data || "" == data){
        toast.warn(`No Recordings found for ${schedule?.ProgramName}`);
      }
      setRecordings(data);
    })
  }

  useEffect(() => {
    setChecked(checked);
  }, [checked])

  const submitRecordings = () => {
    var cbs = document.getElementsByTagName('input');
    for(var i=0; i < cbs.length; i++) {
      if(cbs[i].type == 'checkbox') {
        if (cbs[i].checked) {
          checked.push(parseInt(cbs[i].value));
        }
      }
    }
    var data = api.broadcast.postRecordingSplit(checked)
      .then(data => {
        toast.success(`Successfully split ${recordings.length} recordings into ${data} files`);
      });
  }
  
  return (
    <div id='recordingSearch' className='container'>
      <form onSubmit={handleSubmit(onSubmit)}>
        <select {...register("Station", { required: true })} onChange={handleOnChange}>
          {/* <option value="947">947</option> */}
          {stations.map((item: StationType, i: number) => {
            return (
              <option key={i} value={item.Id} label={item.Name} />
            )
          })}
        </select>
        <select {...register("Program", { required: true })} onChange={handleOnChange}>
          {/* <option value="Main News @ 06:00">Main News @ 06:00</option>
          <option value=" Main News @ 13:00"> Main News @ 13:00</option> */}
          {programSchedules.map((item: StationProgramScheduleType, i: number) => {
            return (
              <option key={i} value={item.ProgramScheduleId} label={item.ProgramName + " | " + item.DayOfWeek + " | " + item.StartTime} />
            )
          })}
        </select>

        <button type="submit" className='btn'>
          <i className='fas fa-search' />
        </button>
      </form>
      
      <div id='results'>
        <Table 
          headers={{
            Id: "ID",
            RecorderId: "REC ID",
            // FilePath: "PATH",
            StartTime: "START",
            Duration: "DURATION (s)",
            FileSize_kb: "SIZE (kB)",
            DT: "DATE",
            // IsDeleted: "DELETED"
          }}
          items={data}
          customRenderers={{
            StartTime: (item) => (
              new Date(item.StartTime).toLocaleTimeString()
            ),
            DT: (item) => (
              new Date(item.DT).toLocaleDateString()
            ),
            Duration: (item) => (
              new Date(item.DT).getSeconds()
            )
          }}
        />
        {showEndResults ?  <p id="end-results"> ~ END OF RESULTS ~ </p> : null}
      </div>
      <div className='btn-group'>
        {!showEndResults ?
          <button id='load' onClick={loadMore}>
            <span>MORE</span>
          </button>
          :
          <button id='load' disabled>
            <span>MORE</span>
          </button>
        }
        <button id='submitRecordings' onClick={submitRecordings}>
          <span>SUBMIT</span>
        </button>
      </div>
    </div>
  );
}